import { render, staticRenderFns } from "./PesanList.vue?vue&type=template&id=4d999414&"
import script from "./PesanList.vue?vue&type=script&lang=js&"
export * from "./PesanList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports